"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactFinalForm = require("react-final-form");

var _ramda = require("ramda");

var _reactAsyncClient = require("react-async-client");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _errors = _interopRequireWildcard(require("../../constants/errors"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    padding: 8px 15px;\n    margin: 15px;\n    background-color: #fff1f0;\n    border: 1px solid #ffa39e;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Alert = _styledComponents["default"].div(_templateObject());

var _default = function _default(WrappedComponent) {
  var _temp;

  var formOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var enableReinitialize = (0, _ramda.has)('enableReinitialize', formOptions) ? formOptions.enableReinitialize : true;
  var FormWithHandlers = (0, _reactAsyncClient.withAsyncHandlers)(function (_ref) {
    var formAction = _ref.formAction;
    return formAction && formAction.dispatch && {
      formAction: {
        successHandler: function successHandler(props) {
          props.onSubmitSuccess && props.onSubmitSuccess(props);
        },
        errorHandler: function errorHandler(props) {
          props.onSubmitFail && props.onSubmitFail(props);
        }
      }
    } || {};
  })(WrappedComponent);
  return _temp = /*#__PURE__*/function (_Component) {
    _inherits(FormWrapper, _Component);

    var _super = _createSuper(FormWrapper);

    function FormWrapper(_props) {
      var _this;

      _classCallCheck(this, FormWrapper);

      _this = _super.call(this, _props);

      _defineProperty(_assertThisInitialized(_this), "getInitialValues", function () {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;
        return formOptions.mapPropsToValues ? formOptions.mapPropsToValues(props) : {};
      });

      _defineProperty(_assertThisInitialized(_this), "isSubmitting", function () {
        var formAction = _this.props.formAction;
        return formAction && formAction.dispatch && formAction.meta.pending;
      });

      _defineProperty(_assertThisInitialized(_this), "onSubmit", function (values) {
        var formAction = _this.props.formAction;

        if (formAction) {
          var mapBeforeSubmit = _this.props.mapBeforeSubmit || formOptions.mapBeforeSubmit;
          var dispatch = formAction.dispatch || formAction;

          if (!_this.isSubmitting()) {
            dispatch(mapBeforeSubmit ? mapBeforeSubmit(values, _this.props) : values, _this.props);
          }
        }
      });

      _defineProperty(_assertThisInitialized(_this), "validate", function (values) {
        var schema = _this.getValidationSchema();

        if (!schema) {
          return {};
        }

        try {
          schema.validateSync(values, {
            abortEarly: false
          });
        } catch (e) {
          return e.inner.reduce(function (errors, error) {
            var path = error.path.split(/\.|\].|\[/).map(function (p) {
              return isNaN(Number(p)) ? p : Number(p);
            });
            return (0, _ramda.assocPath)(path, error.message, errors);
          }, {});
        }
      });

      _defineProperty(_assertThisInitialized(_this), "getValidationSchema", function () {
        var schema = formOptions.validationSchema;
        return schema ? typeof schema === 'function' ? schema(_this.props) : schema : null;
      });

      _defineProperty(_assertThisInitialized(_this), "getError", function () {
        var error = (0, _ramda.path)(['meta', 'error', 'data', 'errors', 0, 'message'], _this.props.formAction);
        var networkError = (0, _ramda.path)(['meta', 'error', 'origin', 'message'], _this.props.formAction);
        return _errors["default"][error] || networkError;
      });

      _this.state = {
        initialValues: _this.getInitialValues(_props)
      };
      return _this;
    }

    _createClass(FormWrapper, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(prev) {
        var initialValues = this.getInitialValues();

        if (!(0, _ramda.equals)(initialValues, this.getInitialValues(prev)) && enableReinitialize) {
          this.setState({
            initialValues: initialValues
          });
        }
      }
    }, {
      key: "renderError",
      value: function renderError(error) {
        return error && /*#__PURE__*/_react["default"].createElement(Alert, null, error || _errors.DEFAULT_ERROR);
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var error = this.getError();
        return /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Form, {
          onSubmit: this.onSubmit,
          validate: this.validate,
          subscription: {
            submitting: true,
            invalid: true,
            submitFailed: true,
            error: true
          },
          initialValues: this.state.initialValues,
          render: function render(props) {
            return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, error && _this2.renderError(error), /*#__PURE__*/_react["default"].createElement("form", {
              onSubmit: props.handleSubmit,
              noValidate: true
            }, /*#__PURE__*/_react["default"].createElement(FormWithHandlers, _extends({}, _this2.props, props))));
          }
        });
      }
    }]);

    return FormWrapper;
  }(_react.Component), _temp;
};

exports["default"] = _default;